import { useThemeStore } from '@/store';
import {
  Dialog,
  DialogPanel,
  Transition,
  TransitionChild
} from '@headlessui/react';
import { Fragment, useEffect, useState } from 'react';

interface Props {
  isOpen: boolean;
  closeModal: () => void;
  direction?: string;
  classNameStr?: string;
  dialogClassName?: string;
  children?: React.ReactNode;
}

export const PopupComponents = (props: Props) => {
  const {
    isOpen,
    closeModal,
    classNameStr,
    direction = 'LtoR',
    children,
    dialogClassName
  } = props;
  const [start, setStart] = useState('-translate-x-full');
  const [end, setEnd] = useState('translate-x-0');
  useEffect(() => {
    if (direction === 'LtoR') {
      setStart('-translate-x-full');
      setEnd('translate-x-0');
    } else if (direction === 'RtoL') {
      setStart('translate-x-full');
      setEnd('translate-x-0');
    } else if (direction === 'TtoB') {
      setStart('-translate-y-full');
      setEnd('translate-y-0');
    } else if (direction === 'BtoT') {
      setStart('translate-y-full');
      setEnd('translate-y-0');
    }
  }, [direction]);
  const { theme } = useThemeStore();

  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog
          as="div"
          className={`w-full relative m-auto z-50 overflow-hidden flex ${theme} ${dialogClassName}`}
          onClose={closeModal}
        >
          <TransitionChild
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 m-auto w-[393px] h-full bg-black bg-opacity-25" />
          </TransitionChild>

          <div className="fixed inset-0 w-[393px] h-full m-auto overflow-hidden">
            <TransitionChild
              as={Fragment}
              enter="transition ease-out duration-300"
              enterFrom={`opacity-0 ${start}`}
              enterTo={`opacity-100 ${end}`}
              leave="transition ease-in duration-300"
              leaveFrom={`opacity-100 ${end}`}
              leaveTo={`opacity-0 ${start}`}
            >
              <DialogPanel className={`absolute transform ${classNameStr}`}>
                {children}
              </DialogPanel>
            </TransitionChild>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};
